/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Featureprivacydescription2Inputs */

const he_extension_featureprivacydescription2 = /** @type {(inputs: Extension_Featureprivacydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התוסף לא אוסף מידע אישי ומכבד את הפרטיות שלכם`)
};

const en_extension_featureprivacydescription2 = /** @type {(inputs: Extension_Featureprivacydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The extension does not collect personal data and respects your privacy`)
};

/**
* | output |
* | --- |
* | "The extension does not collect personal data and respects your privacy" |
*
* @param {Extension_Featureprivacydescription2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_featureprivacydescription2 = /** @type {((inputs?: Extension_Featureprivacydescription2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Featureprivacydescription2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_featureprivacydescription2(inputs)
	return en_extension_featureprivacydescription2(inputs)
});
export { extension_featureprivacydescription2 as "extension_featurePrivacyDescription" }